import { ViewBasicInterface } from 'pf-frontend-common/src/module/view/basic.interface';
import { ModalServiceInterface } from 'pf-frontend-common/src/service/modal/service.interface';

import { MyAccountConfirmationViewStore } from 'common/module/my-account/confirmation/view-store';
import { MyAccountPopupContentTypeEnum } from 'common/module/my-account/popup/content-type.enum';
import { ViewDynamicInterface } from 'common/module/view/dynamic.interface';

import { MyAccountConfirmationOptionInterface } from '../confirmation/option.interface';

export class MyAccountPopupView implements ViewBasicInterface {
  /**
   * Constructor
   */
  constructor(
    private modalService: ModalServiceInterface,
    private myAccountConfirmationViewDynamic: ViewDynamicInterface<MyAccountConfirmationViewStore>
  ) {}

  /**
   * @inheritDoc
   */
  public initialize(options: MyAccountConfirmationOptionInterface): void {
    // Initialize subviews
    this.initConfirmation(options);
  }

  /**
   * @inheritDoc
   */
  public render(): void {
    this.renderConfirmation();
  }

  /**
   * @inheritDoc
   */
  public open(contentType: MyAccountPopupContentTypeEnum = MyAccountPopupContentTypeEnum.confirmation): void {
    // Render confirmation popup
    this.myAccountConfirmationViewDynamic.render();

    // Open modal
    this.modalService.open();
  }

  /**
   * @inheritDoc
   */
  public close(): void {
    // Close modal
    this.modalService.close();
  }

  /**
   * Init user confirmation modal
   */
  private initConfirmation(options: MyAccountConfirmationOptionInterface): void {
    this.myAccountConfirmationViewDynamic.initialize({
      element: this.modalService.getContentElement(),
    });

    this.myAccountConfirmationViewDynamic.getViewStore().initialize(options);
  }

  /**
   * Render confirmation modal
   */
  private renderConfirmation(): void {
    this.myAccountConfirmationViewDynamic.render();
  }
}
